import React from 'react';

class CloseWindowPage extends React.Component {
  componentDidMount() {
    window.close();
  }

  render() {
    return (
      <div>
        <h1>Closing...</h1>
      </div>
    );
  }
}

export default CloseWindowPage;
